import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isObject } from "./stuff";
export var toListValue = function toListValue(v, title) {
  if (v == null || v == "") {
    return undefined;
  } else if (isObject(v)) {
    return _objectSpread(_objectSpread({}, v), {}, {
      title: v.title || v.value // fallback to value
    });
  } else {
    return {
      value: v,
      title: title !== undefined ? title : "" + v
    };
  }
};
export var makeCustomListValue = function makeCustomListValue(v) {
  var lv = toListValue(v);
  if (isObject(lv)) {
    return _objectSpread(_objectSpread({}, toListValue(v)), {}, {
      isCustom: true
    });
  } else {
    // only if undefined
    return lv;
  }
};

// convert {<value>: <title>, ..} or [value, ..] to normal [{value, title}, ..]
export var listValuesToArray = function listValuesToArray(listValuesObj) {
  if (Array.isArray(listValuesObj)) return listValuesObj.map(function (v) {
    return toListValue(v);
  });
  if (!isObject(listValuesObj)) return listValuesObj;
  var listValuesArr = [];
  for (var v in listValuesObj) {
    var title = listValuesObj[v];
    listValuesArr.push(toListValue(v, title));
  }
  return listValuesArr;
};

// listValues can be {<value>: <title>, ..} or [{value, title}, ..] or [value, ..]
// todo: same as getListValue() (but args are switched)
export var getItemInListValues = function getItemInListValues(listValues, value) {
  if (Array.isArray(listValues)) {
    var values = listValues.map(function (v) {
      return toListValue(v);
    });
    return values.find(function (v) {
      return "" + v.value === "" + value;
    });
  } else {
    return listValues[value] !== undefined ? toListValue(value, listValues[value]) : undefined;
  }
};
export var getTitleInListValues = function getTitleInListValues(listValues, value) {
  if (listValues == undefined) return value;
  var it = getItemInListValues(listValues, value);
  return it !== undefined ? it.title : value;
};
export var getValueInListValues = function getValueInListValues(listValues, value) {
  if (listValues == undefined) return value;
  var it = getItemInListValues(listValues, value);
  return it !== undefined ? it.value : value;
};
export var mapListValues = function mapListValues(listValues, mapFn) {
  var ret = [];
  if (Array.isArray(listValues)) {
    var _iterator = _createForOfIteratorHelper(listValues),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var v = _step.value;
        var lv = mapFn(toListValue(v));
        if (lv != null) ret.push(lv);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else {
    for (var value in listValues) {
      var _lv = mapFn(toListValue(value, listValues[value]));
      if (_lv != null) ret.push(_lv);
    }
  }
  return ret;
};
export var searchListValue = function searchListValue(search, listValues) {
  return mapListValues(listValues, function (lv) {
    return "".concat(lv.value).indexOf(search) != -1 || lv.title.indexOf(search) != -1 ? lv : null;
  }).filter(function (v) {
    return v !== null;
  }).shift();
};
export var getListValue = function getListValue(selectedValue, listValues) {
  return mapListValues(listValues, function (lv) {
    return "" + lv.value === "" + selectedValue ? lv : null;
  }).filter(function (v) {
    return v !== null;
  }).shift();
};